<script setup lang="ts">
import type { Employee } from 'types/blocks';

defineProps<{
  employeeData: Employee;
  imagePortrait: boolean;
}>();
</script>

<template>
  <article class="relative flex flex-col">
    <figure
      v-if="employeeData.image?.url"
      class="w-full overflow-clip"
    >
      <BaseImage
        class="mb-6 w-full"
        :class="{ 'rounded-full': imagePortrait }"
        :image="employeeData.image"
        format="webp"
        :width="250"
        :height="250"
      />
    </figure>

    <div
      v-if="employeeData.name || employeeData.title"
      class="flex flex-col"
    >
      <h6
        v-if="employeeData.name"
        class="mb-1 text-center font-semibold"
      >
        {{ employeeData.name }}
      </h6>

      <p
        v-if="employeeData.title"
        class="text-center"
      >
        {{ employeeData.title }}
      </p>
    </div>
  </article>
</template>
